import type { PropsWithChildren, ReactNode } from 'react';
import { clsx } from 'clsx';
import { VerticalStack, type VerticalStackProps } from '../alignment/vertical-stack';
import { Typography } from '../typography';
import styles from './empty-illustration.module.scss';

interface EmptyIllustrationProps extends VerticalStackProps {
  icon?: ReactNode;
  message?: ReactNode;
  subMessage?: ReactNode;
}

export function EmptyIllustration({ children, className, icon, message, subMessage, ...rest }: PropsWithChildren<EmptyIllustrationProps>) {
  return (
    <VerticalStack align="center" className={clsx(styles.emptyIllustration, className)} gap={7} inlineAlign="center" {...rest}>
      <div className={styles.illustration}>{icon}</div>

      <VerticalStack align="center" gap={2} inlineAlign="center">
        <Typography align="center" lineHeight="1.625rem" size="1.125rem" tone="neutral-dk" variant="heading">
          {message}
        </Typography>

        {subMessage ? (
          <Typography align="center" lineHeight="1.5rem" size="0.875rem" tone="neutral-dk">
            {subMessage}
          </Typography>
        ) : null}
        {children}
      </VerticalStack>
    </VerticalStack>
  );
}
